function runPo2go(){
  var store_config = {
    "punchout_only":0,
    "transfer_label":"Transfer Cart",
    "custom_style": "body.punchout a.header__link.action-area__link { display: none; } body.punchout div.button-group.button-group--loose.button-group--fit button.button.button--primary { display: none !important; } .cart-recap__notices.rte p { visibility: hidden; position: relative; padding-bottom: 25px; } .cart-recap__notices.rte p::before { content: 'Taxes and shipping calculated when the order is confirmed by Life Fitness.'; visibility: visible; position: absolute; left: 0; top: 0; display: block; }",  
    "checkout_selector":"button[name=\"checkout\"]",
    "transfer_selector":"button[name=\"transfer_items\"]",
    "transfer_btn_html":"<button type=\"submit\" name=\"transfer_items\" class=\"cart-recap__checkout button button--primary button--full button--large checkout\" onClick=\"POSession.extension.transferCart(); return false;\" >Transfer Cart</button>",
    "return_selector": "header",
    "return_btn_html": "<button type=\"submit\" name=\"close_punchout\" class=\"btn return_btn\" onClick=\"POSession.cancel();\" >Close PunchOut<\/button>"
  };
   
    POExt = new Po2go_Shopify(store_config);     
    POSession = new Po2go({
        'account':'',
        'punchout_only' : store_config.punchout_only,
        'extension' : POExt
    });
    POSession.init();
    POSession.extension.setupPage();
    POSession.extension.returnToProcButton(); // Add this if you need to add a Close PunchOut button; don't forget to add your return_selector and return_btn_html to the store_config
}